{
  "standard": {
    "color1": "#3b4c53",
    "color2": "#ce3d3a",
    "color3": "#f6d541",
    "color4": "#fcfae0",
    "color5": "#202020"
  },
  "dark": {
    "background": "#242523",
    "positive": "#008C4D",
    "negative": "#E62020"
  },
  "light": {
    "background": "#f6f6f3",
    "positive": "#008C4D",
    "negative": "#E62020"
  },
  "statusColor": {
    "good": {
      "background": "#388E3C",
      "color": "#FAFAFA"
    },
    "warning": {
      "background": "#F57C00",
      "color": "#FAFAFA"
    },
    "error": {
      "background": "#D32F2F",
      "color": "#FAFAFA"
    },
    "info": {
      "background": "#0288D1",
      "color": "#FAFAFA"
    },
    "danger": {
      "background": "#d32f2f",
      "color": "#FAFAFA"
    },
    "blueGray": {
      "background": "#455A64",
      "color": "#FAFAFA"
    },
    "gray": {
      "background": "#616161",
      "color": "#FAFAFA"
    },
    "deepOrange": {
      "background": "#E64A19",
      "color": "#FAFAFA"
    },
    "cyan": {
      "background": "#0097A7",
      "color": "#FAFAFA"
    },
    "pink": {
      "background": "#C2185B",
      "color": "#FAFAFA"
    },
    "purple": {
      "background": "#7B1FA2",
      "color": "#FAFAFA"
    },
    "selected": {
      "background": "#7B1FA2",
      "color": "#FAFAFA"
    },
    "empty": {
      "background": "#90A4AE",
      "color": "#424242"
    },
    "production": {
      "background": "#388E3C",
      "color": "#FAFAFA"
    },
    "delay": {
      "background": "#D32F2F",
      "color": "#FAFAFA"
    },
    "scheduleDay": {
      "background": "#E0CB0A",
      "color": "#E62020"
    }
  },
  "charts": {
    "red": "#ef5350",
    "pink": "#ec407a",
    "purple": "#ab47bc",
    "deepPurple": "#7e57c2",
    "indigo": "#5c6bc0",
    "blue": "#42a5f5",
    "lightBlue": "#29b6f6",
    "cyan": "#26c6da",
    "teal": "#26a69a",
    "green": "#66bb6a",
    "lightGreen": "#9ccc65",
    "lime": "#d4e157",
    "yellow": "#ffee58",
    "amber": "#ffca28",
    "orange": "#ffa726",
    "deepOrange": "#ff7043",
    "gray": "#616161"
  },
  "list": [
    "#ef5350",
    "#ec407a",
    "#ab47bc",
    "#7e57c2",
    "#5c6bc0",
    "#42a5f5",
    "#29b6f6",
    "#26c6da",
    "#26a69a",
    "#66bb6a",
    "#9ccc65",
    "#d4e157",
    "#ffee58",
    "#ffca28",
    "#ffa726",
    "#ff7043"
  ],
  "rgbColor": [
    "96, 125, 139",
    "236, 64, 122",
    "126, 87, 194",
    "66 165, 245",
    "38, 198, 218",
    "102, 187, 106",
    "212, 225, 87",
    "255, 202, 40",
    "255, 112, 67"
  ]
}
